import { render, staticRenderFns } from "./menuItemForm.vue?vue&type=template&id=5b3178f7&scoped=true"
import script from "./menuItemForm.vue?vue&type=script&lang=js"
export * from "./menuItemForm.vue?vue&type=script&lang=js"
import style0 from "./menuItemForm.vue?vue&type=style&index=0&id=5b3178f7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3178f7",
  null
  
)

export default component.exports